import { Menu, Button, Icon } from "antd";

import WeaCollect from "../wea-collect";
import RightMenu from "../wea-right-menu/RightMenu";

import "./index.less";
import middleware from "../../middleware";
import WeaLocaleProvider from "../wea-locale-provider";

const getLabel = WeaLocaleProvider.getLabel;
const Item = Menu.Item;
class WeaMoreButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: this.props.visible || false,
      collectVisable: false,
      showBtn: false
    };
  }

  componentDidMount() {
    if (this.RightMenu && !this.RightMenu.isEmpty)
      this.setState({ showBtn: true });
  }

  componentWillReceiveProps(nextProps) {
    const { visible, showBtn } = this.state;
    let nState = null;
    "visible" in nextProps &&
      nextProps.visible !== visible &&
      (nState = { visible: nextProps.visible });
    const showbtn = this.RightMenu && !this.RightMenu.isEmpty;
    showbtn !== showBtn && (nState = { showBtn: showbtn });
    nState && this.setState(nState);
  }

  render() {
    const { visible, collectVisable, showBtn } = this.state;
    const {
      onVisibleChange,
      collectParams,
      onLeaveMenu,
      className = "",
      style
    } = this.props;
    return (
      <div
        className={`wea-more-button ${className}`}
        style={style}
        onMouseLeave={() => {
          if (typeof onLeaveMenu === "function") onLeaveMenu();
          else {
            if (!this.props.visible) this.setState({ visible: false });
          }
        }}
      >
        <div
          className={`wea-right-menu wea-more-button-menu ${!visible &&
            "displayNone"}`}
        >
          <RightMenu {...this.props} ref={el => (this.RightMenu = el)} />
        </div>
        <div className={`${!showBtn && "displayNone"}`}>
          <Button
            type="ghost"
            onClick={() => {
              if (typeof onVisibleChange === "function") onVisibleChange();
              else {
                if (!this.props.visible) this.setState({ visible: !visible });
              }
            }}
          >
            {getLabel(17499, "更多")}
            <Icon type="double-right" className="wea-f12" />
          </Button>
        </div>
      </div>
    );
  }
}
const Com = middleware(WeaMoreButton, "WeaMoreButton");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-more-button/index.js